import React from 'react';
import { createRoot } from 'react-dom/client';
import OnayPopup from '../components/OnayPopup';

let confirmRoot = null;
let confirmContainer = null;

export const confirmAsync = (mesaj, baslik = 'Onay') => {
  return new Promise((resolve) => {
    if (!confirmContainer) {
      confirmContainer = document.createElement('div');
      document.body.appendChild(confirmContainer);
      confirmRoot = createRoot(confirmContainer);
    }

    const cleanup = () => {
      confirmRoot.render(<OnayPopup acik={false} />);
    };

    const handleEvet = () => {
      cleanup();
      resolve(true);
    };

    const handleHayir = () => {
      cleanup();
      resolve(false);
    };

    confirmRoot.render(
      <OnayPopup 
        acik={true} 
        baslik={baslik} 
        mesaj={mesaj} 
        onEvet={handleEvet} 
        onHayir={handleHayir} 
      />
    );
  });
};

